module.exports = __webpack_public_path__ + "static/media/010.7bb0be14.jpg";